/* eslint-disable @typescript-eslint/default-param-last */
import { ADD_BREADCRUMBS, REMOVE_BREADCRUMBS } from '../constants/ActionTypes';
import initialState from '../store/initialState';
import { IBreadCrumbsActionType } from '../types/breadcrumbs.types';

const breadcrumbsReducer = (
  state = initialState.breadcrumbs,
  action: IBreadCrumbsActionType
) => {
  switch (action.type) {
    case ADD_BREADCRUMBS:
      return [...state, ...action.payload];
    case REMOVE_BREADCRUMBS:
      return [];
    default:
      return state;
  }
};

export default breadcrumbsReducer;
